import { render, staticRenderFns } from "./latest-app-contacts.vue?vue&type=template&id=51993993&scoped=true"
import script from "./latest-app-contacts.vue?vue&type=script&lang=js"
export * from "./latest-app-contacts.vue?vue&type=script&lang=js"
import style0 from "./latest-app-contacts.vue?vue&type=style&index=0&id=51993993&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51993993",
  null
  
)

export default component.exports